import { useEffect, useState } from "react";
import api from "@/lib/api";

// Shared public landing config (/api/landing) for Brand, SiteHead, landing, signup, admin.
let _cache = null;
let _inflight = null;
const _listeners = new Set();

function emit(data) {
  _cache = data;
  _listeners.forEach((fn) => fn(data));
}

function normalize(data) {
  if (!data || typeof data !== "object") return { _loaded: true };
  const { ok, ...rest } = data;
  return { ...rest, _loaded: true };
}

/** Call after Super Admin saves landing content so every Brand updates immediately. */
export function setSiteConfig(data) {
  const next = normalize(data);
  _inflight = Promise.resolve(next);
  emit(next);
  return next;
}

export function refreshSiteConfig() {
  _inflight = api
    .get("/landing")
    .then(({ data }) => {
      const next = normalize(data);
      emit(next);
      return next;
    })
    .catch(() => {
      const next = { ...(_cache || {}), _loaded: true };
      emit(next);
      return next;
    });
  return _inflight;
}

export function useSiteConfig() {
  const [config, setConfig] = useState(_cache || {});

  useEffect(() => {
    const onChange = (d) => setConfig(d);
    _listeners.add(onChange);
    if (_cache) setConfig(_cache);
    if (!_inflight) refreshSiteConfig();
    else _inflight.then((d) => { if (d) setConfig(d); });
    return () => { _listeners.delete(onChange); };
  }, []);

  return config || {};
}
